import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "INCOMPLETE-BOX-ALERT font-medium text-gray-800 py-4 px-2 rounded mb-4"
}
const _hoisted_4 = {
  key: 2,
  class: "rounded border p-4 mt-2 bg-white"
}
const _hoisted_5 = { class: "font-light" }
const _hoisted_6 = { class: "flex-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "whitespace-nowrap font-bold text-sm" }, "Maximum Buy Price", -1)
const _hoisted_8 = { class: "border border-gray-400 rounded flex" }
const _hoisted_9 = { class: "flex-1 text-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "¢", -1)
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "flex justify-between mt-4 mb-4" }
const _hoisted_13 = {
  type: "button",
  class: "inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-slate-400 hover:bg-slate-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
}
const _hoisted_14 = { class: "mt-1 relative rounded-md shadow-sm" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 sm:text-sm" }, " Rounds ")
], -1)
const _hoisted_16 = {
  type: "button",
  class: "inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-slate-400 hover:bg-slate-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MinusSmallIcon = _resolveComponent("MinusSmallIcon")!
  const _component_PlusSmallIcon = _resolveComponent("PlusSmallIcon")!
  const _directive_autowidth = _resolveDirective("autowidth")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.data.roundsAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.data.roundsAvailable < _ctx.minBoxSize)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("h1", null, "You need at least " + _toDisplayString(_ctx.minBoxSize) + " Rounds to ship this product", 1),
                (!_ctx.completeBoxOpen)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCompleteBox && _ctx.toggleCompleteBox(...args))),
                      class: "INCOMPLETE-BOX-BUTTON mt-2 px-3 py-1 text-sm font-light rounded focus:outline-none",
                      style: {"text-shadow":"1px 1px 0 rgba(255,255,255,0.6)"}
                    }, "Complete Box"))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleCompleteBox && _ctx.toggleCompleteBox(...args))),
                      class: "INCOMPLETE-BOX-BUTTON mt-2 px-3 py-1 text-sm font-light rounded focus:outline-none",
                      style: {"text-shadow":"1px 1px 0 rgba(255,255,255,0.6)"}
                    }, "Close")),
                (_ctx.completeBoxOpen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("h1", _hoisted_5, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.minBoxSize - _ctx.data.roundsAvailable), 1),
                        _createTextVNode(" rounds needed to complete box.")
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", {
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.decrCent && _ctx.decrCent(...args))),
                            class: "inline-block cursor-pointer bg-gray-600 p-3 text-white hover:bg-gray-500"
                          }, "-1¢"),
                          _createElementVNode("div", _hoisted_9, [
                            _withDirectives(_createElementVNode("input", {
                              class: "inline border-0 text-right w-16 p-0 my-3 focus:outline-none focus:border-none",
                              type: "text",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.milliCents) = $event))
                            }, null, 512), [
                              [_directive_autowidth, { minWidth: `${_ctx.milliCents.toString().length * 10}px` }],
                              [_vModelText, _ctx.milliCents]
                            ]),
                            _hoisted_10
                          ]),
                          _createElementVNode("div", {
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.incrCent && _ctx.incrCent(...args))),
                            class: "inline-block cursor-pointer bg-gray-600 p-3 text-white hover:bg-gray-500"
                          }, "+1¢")
                        ])
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submitOrder && _ctx.submitOrder(...args))),
                        class: "my-3 w-full relative items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-slate-600 hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      }, "Submit Buy Order")
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, " This product could ship in " + _toDisplayString(_ctx.boxSizes) + " round boxes. You have " + _toDisplayString(_ctx.data.roundsAvailable) + " rounds available ", 1),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", _hoisted_13, [
              _createVNode(_component_MinusSmallIcon, {
                onClick: _ctx.subtractRounds,
                class: "h-5 w-5",
                "aria-hidden": "true"
              }, null, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.boxesInput) = $event)),
                type: "text",
                name: "boxes",
                class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md",
                placeholder: "0",
                "aria-describedby": "price-currency"
              }, null, 512), [
                [_vModelText, _ctx.boxesInput]
              ]),
              _hoisted_15
            ]),
            _createElementVNode("button", _hoisted_16, [
              _createVNode(_component_PlusSmallIcon, {
                onClick: _ctx.addRounds,
                class: "h-5 w-5",
                "aria-hidden": "true"
              }, null, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("button", {
            disabled: _ctx.boxesInput <= 0,
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addItemToCart && _ctx.addItemToCart(...args))),
            class: _normalizeClass([_ctx.boxesInput <= 0 ? 'border-slate-200 text-slate-200' : 'border border-slate-500 text-slate-500 hover:text-slate-700 hover:border-slate-700','my-3 w-full mr-2 relative items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'])
          }, " Add To Shipping Cart ", 10, _hoisted_17),
          _createElementVNode("button", {
            disabled: _ctx.boxesInput <= 0,
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openShipping && _ctx.openShipping(...args))),
            class: _normalizeClass([_ctx.boxesInput <= 0 ?'border-slate-200 text-slate-200' : 'border border-slate-500 text-slate-500 hover:text-slate-700 hover:border-slate-700','my-3 w-full mr-2 relative items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'])
          }, " Ship Single Product ", 10, _hoisted_18)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_19, "You have no inventory to ship."))
  ]))
}